module.exports = __webpack_public_path__ + "static/media/blender.465dfddb.png";